import type { ApiRequestBody } from "@/lib/api/api-type-helper";
import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";
import type { operations } from "@/lib/api/schema";

export async function getCertificationsCount(
  params: Partial<
    NonNullable<
      operations["CertificationController_getCertificationsCount_v2"]["parameters"]["query"]
    >
  >,
) {
  const res = await apiClient.GET("/v2/certifications/count", {
    params: { query: params },
  });

  return getDataOrThrowApiError(res);
}

export async function getCertificationsList(
  params: Partial<
    NonNullable<
      operations["CertificationController_getCertifications_v2"]["parameters"]["query"]
    >
  >,
) {
  const res = await apiClient.GET("/v2/certifications", {
    params: { query: params },
  });

  return getDataOrThrowApiError(res);
}

export const updateCertification = async (
  id: string,
  body: ApiRequestBody<"/v2/certifications/{id}", "patch">,
) => {
  const res = await apiClient.PATCH("/v2/certifications/{id}", {
    params: {
      path: {
        id: id,
      },
    },
    body,
  });
  return getDataOrThrowApiError(res);
};

export const deleteCertification = async (id: string) => {
  const res = await apiClient.DELETE("/v2/certifications/{id}", {
    params: {
      path: {
        id: id,
      },
    },
  });
  return getDataOrThrowApiError(res);
};
